import { openDB, type DBSchema, type IDBPDatabase } from "idb"

interface ListenWebDB extends DBSchema {
  audioPositions: {
    key: string // uuid
    value: number // audioPosition
  }
}

const OBJECT_STORE_NAME = "audioPositions"

class IndexDBService {
  private storeName = "listenWeb"
  private storeVersion = 1
  private db: IDBPDatabase<ListenWebDB> | null = null

  constructor() {}

  async init() {
    this.db = await openDB<ListenWebDB>(this.storeName, this.storeVersion, {
      upgrade(db) {
        // Create object store if it doesn't exist
        if (!db.objectStoreNames.contains(OBJECT_STORE_NAME)) {
          db.createObjectStore(OBJECT_STORE_NAME)
        }
      },
    })
    return this.db
  }

  async saveAudioPosition({ id, position }: { id: string; position: number }) {
    if (!this.db) return
    await this.db.put(OBJECT_STORE_NAME, position, id)
  }

  async getAudioPosition(id: string) {
    if (!this.db) return 0
    const position = await this.db.get(OBJECT_STORE_NAME, id)
    return position || 0
  }

  async deleteAudioPosition(id: string) {
    if (!this.db) return
    await this.db.delete(OBJECT_STORE_NAME, id)
  }
}

export const indexDBService = new IndexDBService()
